import { Plus } from '@phosphor-icons/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'core/components';
import { Color } from 'theme/enums';

import { AddProjectCustomer } from './AddProjectCustomer';

interface IProps {
  pricingProfileId: number;
  projectId: number;
  disabled?: boolean;
}

export const AddProjectCustomerButton = ({ pricingProfileId, projectId, disabled }: IProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const { t } = useTranslation();

  const onOpen = () => setIsOpen(true);
  const onClose = () => setIsOpen(false);

  return (
    <>
      <Button
        text={t('buttonLabelAddCustomer')}
        color={Color.SUCCESS}
        startDecorator={<Plus />}
        onClick={onOpen}
        disabled={disabled}
      />

      <AddProjectCustomer
        isOpen={isOpen}
        onClose={onClose}
        pricingProfileId={pricingProfileId}
        projectId={projectId}
      />
    </>
  );
};
